export * from "./main1view1.config.mjs";
export * from "./main1view2.config.mjs";
export * from "./main1view3.config.mjs";
export * from "./main1view4.config.mjs";
export * from "./main1view5.config.mjs";
